import { Box, Grid, Typography, IconButton, Button } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import logo from "..//../assets/Fh_FullLogo.png";
import { Link } from "react-router-dom";
import { ArrowForward, Facebook, Instagram, LinkedIn, Twitter, YouTube } from "@mui/icons-material";
import { useTheme } from '../../ThemeContext';

const socialLinks = [
  { icon: <Facebook />, label: "Facebook", href: "https://www.facebook.com/people/Film-hook/61568589043197/#" },
  { icon: <Instagram />, label: "Instagram", href: "https://www.instagram.com/filmhookapps/?next=%2F" },
  { icon: <YouTube />, label: "YouTube", href: "https://www.youtube.com/@Film-hookapps/about" },
  { icon: <LinkedIn />, label: "LinkedIn", href: "https://www.linkedin.com/in/film-hook-apps-865337298/" },
];

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Features", path: "/features" },
  { label: "Contact Us", path: "/contact" },
];

const legalLinks = [
  { label: "Privacy Policy", path: "/privacyPolicyAll" },
  { label: "Terms & Conditions", path: "/termsAndCondition" },
  { label: "Terms of Service", path: "/terms-of-service" },
  { label: "Age Suitability", path: "/age-suitability" },
  { label: "Child Safety", path: "/child-safety" },
  { label: "Data Safety", path: "/data-safety" },
  { label: "Account Deletion", path: "/account-deletion" },
];

const buttonData = [
  { label: 'Download App', href: 'https://play.google.com/store/apps/details?id=com.filmhookapps&hl=en_IN' }
];

const Footer = () => {
  const { isDarkMode } = useTheme();
  return (
    <Box
      component="footer"
      sx={{
        background: isDarkMode
          ? 'linear-gradient(180deg, rgba(10,14,26,0.98) 0%, #050812 100%)'
          : 'linear-gradient(180deg, #f0f4ff 0%, #e8eeff 100%)',
        borderTop: isDarkMode ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(7, 164, 245,0.15)',
        py: { xs: 4, md: 6 },
        px: { xs: 3, md: 6 },
        color: isDarkMode ? 'white' : '#0d1530',
        position: 'relative',
        overflow: 'hidden',
        transition: 'background 0.4s ease',
      }}
    >
      {/* Decorative blobs */}
      <Box sx={{
        position: 'absolute', top: 0, left: '-10%', width: '300px', height: '300px',
        background: 'radial-gradient(circle, rgba(7, 164, 245,0.12) 0%, transparent 70%)',
        filter: 'blur(40px)', pointerEvents: 'none',
      }} />
      <Box sx={{
        position: 'absolute', bottom: 0, right: '-5%', width: '250px', height: '250px',
        background: 'radial-gradient(circle, rgba(93,173,226,0.08) 0%, transparent 70%)',
        filter: 'blur(40px)', pointerEvents: 'none',
      }} />

      <Grid container spacing={5} sx={{ position: 'relative', zIndex: 1 }}>
        {/* Footer About */}
        <Grid item xs={12} md={3}>
          <Box mb={2.5}>
            <img src={logo} alt="Filmhook Logo" width={150} style={{ padding: "5px", borderRadius: "10px" }} />
          </Box>
          <Typography variant="body2" sx={{ color: isDarkMode ? 'rgba(255,255,255,0.65)' : '#4a5568', lineHeight: 1.8, mb: 3 }}>
            Connecting Creators, Inspiring the World. The ultimate social media and professional networking app for the film industry.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1.5, mt: 2 }}>
            {socialLinks.map((social, index) => (
              <IconButton
                key={index}
                href={social.href}
                aria-label={social.label}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  background: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(7, 164, 245,0.08)',
                  border: isDarkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(7, 164, 245,0.15)',
                  borderRadius: '50%',
                  width: 36,
                  height: 36,
                  color: isDarkMode ? 'rgba(255,255,255,0.75)' : '#07a4f5',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #07a4f5, #5dade2)',
                    border: '1px solid transparent',
                    color: 'white',
                    transform: 'scale(1.1)',
                  },
                }}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>
        </Grid>

        {/* Contact Info */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" gutterBottom fontWeight={600} sx={{ color: isDarkMode ? 'white' : '#0d1530', mb: 2 }}>
            Contact Info
          </Typography>
          <Box display="flex" alignItems="flex-start" mb={1.5}>
            <LocationOnIcon sx={{ mr: 1, mt: 0.3, color: '#5dade2', flexShrink: 0 }} />
            <Typography variant="body2" sx={{ color: isDarkMode ? 'rgba(255,255,255,0.65)' : '#4a5568', lineHeight: 1.7 }}>
              Film-hook Mediaapps Pvt Ltd<br/>
              2nd Floor, 'A, MAIN ROAD, 3, Mysore Rd,<br/>
              Near Indian Chetti Petrol Bunk,<br/>
              Nayanda Halli, Bengaluru,<br/>
              Karnataka 560039, India
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" mb={1.5}>
            <PhoneIcon sx={{ mr: 1, color: '#5dade2' }} />
            <Typography variant="body2" sx={{ color: isDarkMode ? 'rgba(255,255,255,0.65)' : '#4a5568' }}>+91 9629757656</Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <EmailIcon sx={{ mr: 1, color: '#5dade2' }} />
            <Typography variant="body2" sx={{ color: isDarkMode ? 'rgba(255,255,255,0.65)' : '#4a5568' }}>support@filmhookapps.com</Typography>
          </Box>
        </Grid>

        {/* Quick & Legal Links */}
        <Grid item xs={12} sm={6} md={4}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="h6" gutterBottom fontWeight={600} sx={{ color: isDarkMode ? 'white' : '#0d1530', mb: 2 }}>
                Quick Links
              </Typography>
              <Box component="ul" sx={{ pl: 0, listStyle: "none", m: 0 }}>
                {quickLinks.map((link) => (
                  <li key={link.path} style={{ marginBottom: '10px' }}>
                    <Link to={link.path} style={{ textDecoration: "none" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          color: isDarkMode ? 'rgba(255,255,255,0.6)' : '#4a5568',
                          transition: 'color 0.2s',
                          '&:hover': { color: '#5dade2' },
                        }}
                      >
                        › {link.label}
                      </Typography>
                    </Link>
                  </li>
                ))}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h6" gutterBottom fontWeight={600} sx={{ color: isDarkMode ? 'white' : '#0d1530', mb: 2 }}>
                Legal & Safety
              </Typography>
              <Box component="ul" sx={{ pl: 0, listStyle: "none", m: 0 }}>
                {legalLinks.map((link) => (
                  <li key={link.path} style={{ marginBottom: '10px' }}>
                    <Link to={link.path} style={{ textDecoration: "none" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          color: isDarkMode ? 'rgba(255,255,255,0.6)' : '#4a5568',
                          transition: 'color 0.2s',
                          '&:hover': { color: '#5dade2' },
                        }}
                      >
                        › {link.label}
                      </Typography>
                    </Link>
                  </li>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {/* Download */}
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6" gutterBottom fontWeight={600} sx={{ color: isDarkMode ? 'white' : '#0d1530', mb: 2 }}>
            Get the App
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {buttonData.map((btn, index) => (
              <Button
                key={index}
                variant="outlined"
                href={btn.href}
                target="_blank"
                endIcon={<ArrowForward />}
                sx={{
                  border: isDarkMode ? '1px solid rgba(255,255,255,0.25)' : '1px solid rgba(7, 164, 245,0.3)',
                  color: isDarkMode ? 'white' : '#07a4f5',
                  fontWeight: 600,
                  borderRadius: '10px',
                  textTransform: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #07a4f5, #5dade2)',
                    border: '1px solid transparent',
                    color: 'white',
                    boxShadow: '0 4px 15px rgba(7, 164, 245,0.4)',
                  },
                }}
              >
                {btn.label}
              </Button>
            ))}
          </Box>
        </Grid>
      </Grid>

      {/* Bottom bar */}
      <Box sx={{ mt: 5, pt: 3, borderTop: isDarkMode ? '1px solid rgba(255,255,255,0.07)' : '1px solid rgba(7, 164, 245,0.1)', textAlign: 'center' }}>
        <Typography variant="caption" sx={{ color: isDarkMode ? 'rgba(255,255,255,0.35)' : '#718096', fontSize: '0.8rem' }}>
          © {new Date().getFullYear()} Filmhook Mediaapps Pvt Ltd. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
